var isCallable = require('../internals/is-callable');

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/a-possible-prototype.js
// module id = 1163
// module chunks = 0